<div id="settingWrapper" class="child-component py-2  px-5">
  <div class="tab-header-section py-2">
    <div class="row">
      <div class="col-sm-12 ">
        <h4>User Preference</h4>
        <p-divider/>
      </div>
    </div>
  </div>
  
  <!-- Column Preference Start -->
    <app-column-preference ></app-column-preference>
  <!-- Column Preference End -->
 <!-- Custom Route Preference Start -->
    <app-custom-route-preference ></app-custom-route-preference>
  <!-- Custom Route Preference End -->
  <!-- Favorite Location List Start -->
  
  <div class="row mt-5">
    <p-divider align="left">
      <h4><b>Favorite Business Location List</b></h4>
    </p-divider>
    <p class="sub-head-favlist-section">Manage Favorite List for your table</p>
    <div class="offset-sm-6 col-sm-6 text-end">
      <button class="pn-button pn-button-primary pn-button-md" type="button" (click)="addNewFavList()">Add</button>
    </div>
  </div>
  <div class="prime-table" >
    <p-table [rowHover]="true" styleClass="p-datatable-striped p-datatable-sm p-datatable-tbody"  [value]="favData"
    [scrollable]="true" scrollHeight="flex">
      <ng-template pTemplate="loadingicon">
        <svg id="ag-loading-overlay" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <circle class="circle" cx="12" cy="12" r="10" stroke-width="3" stroke="#3A5487"></circle>
          <circle class="dot" cx="21.3" cy="16" r="1.48" fill="#3A5487"></circle>
        </svg>
      </ng-template>
      <ng-template pTemplate="header">
          <tr>
              <th id="name">Name</th>
              <th id="blcount">Business Locations</th>
              <th id="actions">Actions</th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-favData >
          <tr>
              <td>{{favData?.name}}</td>
              <td>{{favData?.blids?.length}} ({{favData?.blids | blName: businessLocationsList}})</td>
              <td>
                <i class="pi pi-pen-to-square action-icon" pTooltip="Edit" (click)="edit(favData)"></i>
                <span> <i (click)="deleteFavoriteList(favData)" pTooltip="Delete" class="pi pi-trash action-icon"></i>
                </span>
              </td>
          </tr>
      </ng-template> 
      <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="3">
                <div class="text-center no-record-label">
                    No Records found.
                </div>
            </td>
        </tr>
    </ng-template>
    </p-table> 
  </div>
  <!-- Favorite Location List End -->
</div>

<!-- Add Favorite Business Location Form Start -->
<p-dialog [(visible)]="settingService.formPopupVisible" [draggable]="false" [modal]="true" [style]="{ width: '50%'}">
  <ng-template #header class="dialogHeader">
    <p class="sub-heading">Favorites 
      <span class="d-block">Add Group data to ease of use</span>
    </p>
  </ng-template>
  <app-favoriteform ></app-favoriteform>
  <ng-template #footer>
    <button (click)="submit()"  class=" pn-button pn-button-primary pn-button-md me-1" type="submit" [disabled]="settingService.favoriteForm.invalid"
    >Save</button>
    <button class="pn-button pn-button-tertiary pn-button-md " (click)="settingService.formPopupVisible=false">Cancel</button>
  </ng-template>
</p-dialog>
<!-- Add Favorite Business Location Form End -->

<!-- Delete Dialog Start -->
<ng-template #deleteDialog>
  <h1 mat-dialog-title>Are you sure!</h1>
  <p-dialog>
    You want to delete ?
  </p-dialog>
  <p-dialog>
    <button class="submit button-primary" type="button" matDialogClose="yes">Yes</button>
    <button class="reset button-primary" type="button" matDialogClose="no">No</button>
  </p-dialog>
</ng-template>
<!-- Delete Dialog End -->

